// MOVIES CONTEXT
// movie state and fetch
export const INIT_MOVIES = 'INIT_MOVIES';
export const LOAD_MOVIES = 'LOAD_MOVIES';
export const ADD_MOVIE = 'ADD_MOVIE';
export const GET_MOVIE_BEGIN = 'GET_MOVIE_BEGIN';
export const GET_MOVIE_END = 'GET_MOVIE_END';
export const SET_ALERT = 'SET_ALERT';
// movie card action-btns
export const TOGGLE_FAV = 'TOGGLE_FAV';
export const REMOVE_MOVIE = 'REMOVE_MOVIE';
export const CLEAR_ALL = 'CLEAR_ALL';

// FILTER CONTEXT
// filter and sort form
export const SET_VIEW = 'SET_VIEW';
export const UPDATE_SORT = 'UPDATE_SORT';
export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const UPDATE_PER_PAGE = 'UPDATE_PER_PAGE';
export const FILTER_MOVIES = 'FILTER_MOVIES';
export const SORT_MOVIES = 'SORT_MOVIES';
export const DISPLAY_ALL = 'DISPLAY_ALL';
export const DISPLAY_FAV = 'DISPLAY_FAV';
// pagination and provider
export const UPDATE_PAGINATION = 'UPDATE_PAGINATION';
export const UPDATE_PROVIDER = 'UPDATE_PROVIDER';
export const SET_PAGINATION = 'SET_PAGINATION';
export const PAGINATE = 'PAGINATE';
// movie player
export const UPDATE_CURRENT_MOVIE = 'UPDATE_CURRENT_MOVIE';
export const SET_MODAL = 'SET_MODAL';
